import React, { useEffect, useMemo, useRef, useState } from "react";
import { CountUp } from "countup.js";
import Swal from "sweetalert2";

import moi from "../Assets/moi.jpg";
import cv from "../Assets/Moncv.pdf";
import zetcha from "../ProjetPicture/zetcha.jpeg";
import drwintech from "../ProjetPicture/Drwintech.jpeg";
import juristouch from "../ProjetPicture/juristouch.jpeg";
import oasis from "../ProjetPicture/oasis.jpeg";
import fewu from "../ProjetPicture/fewu.jpeg";
import labef from "../ProjetPicture/labef.jpeg";
import semca from "../ProjetPicture/semca-uac.jpeg";
import cnadbenin  from "../ProjetPicture/cnad.png";
import mdscbenin  from "../ProjetPicture/mdsc.png";
import dgms from "../ProjetPicture/DGMS.png";
import TaskHive from "../ProjetPicture/TaskHive.png";
import filmkpamin from "../ProjetPicture/filmkpamin.png";
import hmticbenin from "../ProjetPicture/hmticbenin.png";

const projects = [
     {
    title: "MDSC Benin",
    type: "Plateforme MOOC",
    image: mdscbenin,
    link: "https://mooc.mdscbenin.org/",
    description:
      "Plateforme de formation en ligne pour le developpement des competences digitales et professionnelles stimule l'innovation et accompagne l'engagement citoyen.",
  },
   {
    title: "CNAD Benin",
    type: "Site institutionnel",
    image: cnadbenin,
    link: "https://cnad.drwintech.com/",
    description:
      "Site officiel du CNAD Benin, concu pour informer sur les activités, ressources et actualités de l'agence nationale de développement de l'administration digitale.",
  },
   {
    title: "Filmkpamin",
    type: "Application web de streaming",
    image: filmkpamin,
    link: "https://filmkpamin.net/",
    description:
    "Filmkpamin est une application web de streaming, conçue pour permettre aux utilisateurs de visionner des contenus video en ligne, suivre leur progression et communiquer efficacement.",
  },
    {
    title: "TaskHive",
    type: "Application web",
    image: TaskHive,
    link: "https://taskhive.velypto.com",
    description:
    "TaskHive est une plateforme de gestion de projets et de collaboration en ligne, conçue pour aider les équipes à organiser leurs tâches, suivre leur progression et communiquer efficacement.",
  },
  {
    title: "DGMS",
    type: "Application web",
    image: dgms,
    link: "https://spf.drwintech.com/",
    description:
    "Systeme de gestion de flottes et de geolocalisation pour Drwintech Inc avec back-office, espace client, suivi GPS, paiements et support operationnel.",
  },
  {
    title: "Drwintech Inc",
    type: "Application web",
    image: drwintech,
    link: "https://drwintech.com/",
    description:
    "Site officiel de l'entreprise Drwintech Inc",
  },
 
  {
    title: "Zetcha",
    type: "Application web",
    image: zetcha,
    link: "https://app.zetcha.com/",
    description:
      "Carte de visite numerique dynamique pour partager facilement ses informations professionnelles.",
  },
  {
    title: "Hmticbenin",
    type: "Site officiel",
    image: hmticbenin,
    link: "https://hmticbenin.com/",
    description:
      "Site officiel de Hmticbenin, concu pour présenter les services et renforcer la presence digitale.",
  },
  {
    title: "Oasis Afrik",
    type: "Plateforme d'accompagnement",
    image: oasis,
    link: "https://www.oasis-afrik.com/",
    description:
      "Plateforme pour la vente de formations en ligne et la recherche d'opportunites professionnelles.",
  },
  {
    title: "Juristouch",
    type: "Legal tech",
    image: juristouch,
    link: "https://juristouch.com/",
    description:
      "Solution web pour accompagner les particuliers et PME dans la redaction de documents juridiques.",
  },
  {
    title: "Fewu Products",
    type: "E-commerce",
    image: fewu,
    link: "https://fewuproducts.com/",
    description:
      "Boutique en ligne pour une marque de produits d'entretien du corps et du cadre de vie.",
  },
  {
    title: "Labef UAC",
    type: "Blog scientifique",
    image: labef,
    link: "https://labef-uac.org/fr/",
    description:
      "Plateforme de publication autour des recherches de laboratoire, biothemes et destinations forestieres.",
  },
  {
    title: "HRH Semca",
    type: "Blog institutionnel",
    image: semca,
    link: "https://hrh.semca-uac.org/",
    description:
      "Blog institutionnel pour diffuser les activités, ressources et actualités du programme.",
  },
];

const services = [
  {
    number: "01",
    title: "Applications web et mobile full-stack",
    icon: "fa-solid fa-code",
    text:
      "Je transforme une idee en produit web robuste: interface, API, base de donnees, integration et mise en production.",
  },
  {
    number: "02",
    title: "Audit et pentest web",
    icon: "fa-solid fa-shield-halved",
    text:
      "J'analyse les risques, teste les vulnerabilites OWASP Top 10 et propose des recommandations claires de remediation.",
  },
  {
    number: "03",
    title: "Deploiement et maintenance",
    icon: "fa-solid fa-server",
    text:
      "Je gere le deploiement sur VPS/Linux, l'automatisation CI/CD et le suivi technique pour garder les projets stables.",
  },
  {
    number: "04",
    title: "Design et experience utilisateur",
    icon: "fa-solid fa-pen-nib",
    text:
      "Je structure des parcours simples, rapides et elegants avec Figma, Bootstrap, React et une vraie attention au detail.",
  },
];

const skills = [
  { name: "JavaScript", icon: "fa-brands fa-js", level: "Front-end" },
  { name: "React.js", icon: "fa-brands fa-react", level: "SPA" },
  { name: "Next.js", icon: "fa-solid fa-layer-group", level: "Full-stack" },
  { name: "Node.js", icon: "fa-brands fa-node", level: "API" },
  { name: "PHP", icon: "fa-brands fa-php", level: "Backend" },
  { name: "Laravel", icon: "fa-brands fa-laravel", level: "MVC" },
  { name: "Python", icon: "fa-brands fa-python", level: "Django" },
  { name: "Flutter", icon: "fa-solid fa-mobile-screen", level: "Mobile" },
  { name: "MySQL", icon: "fa-solid fa-database", level: "Data" },
  { name: "Git/GitHub", icon: "fa-brands fa-git-alt", level: "Versioning" },
  { name: "CI/CD", icon: "fa-solid fa-code-branch", level: "Deploy" },
  { name: "OWASP", icon: "fa-solid fa-bug-slash", level: "Security" },
];

const timeline = [
  {
    period: "03/2024 - 05/2026",
    title: "Developpeur full-stack et pentester",
    place: "Drwintech Inc, Cotonou",
    details:
      "Conception d'applications web, maintenance, optimisation, audits de securite, tests d'intrusion et gestion d'infrastructures cloud VPS.",
  },
  {
    period: "04/2024 - 12/2024",
    title: "Stage academique",
    place: "Drwintech Inc, Benin",
    details:
      "Collaboration client, developpement de fonctionnalites, compatibilite multiplateforme et veille technologique.",
  },
];

const education = [
  {
    period: "09/2022 - 08/2023",
    title: "Certificat professionnel en developpement web full-stack",
    place: "Ecole Internationale du Graphisme, Cotonou ,Aibatin",
  },
  {
    period: "Depuis 2024",
    title: "Pentest web et securite applicative",
    place: "HackTheBox, TryHackMe, autoformation",
  },
];

export default function Body() {
  const yearsRef = useRef(null);
  const projectsRef = useRef(null);
  const clientsRef = useRef(null);
  const [filter, setFilter] = useState("Tous");
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    tel: "",
    service: "",
    message: "",
  });

  const stats = useMemo(
    () => [
      { label: "années d'expérience", value: 2, ref: yearsRef },
      { label: "projets livrés", value: 19, ref: projectsRef },
      { label: "clients accompagnés", value: 12, ref: clientsRef },
    ],
    []
  );

  const filteredProjects =
    filter === "Tous"
      ? projects
      : projects.filter((project) => project.type.includes(filter));

  useEffect(() => {
    stats.forEach(({ ref, value }) => {
      if (!ref.current) return;
      new CountUp(ref.current, value, {
        duration: 2.4,
        startVal: 0,
        suffix: "+",
      }).start();
    });
  }, [stats]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((current) => ({ ...current, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      nom: "",
      prenom: "",
      email: "",
      tel: "",
      service: "",
      message: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://portfolio.velypto.com/index.php", // Remplacez par l'URL de votre API
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        throw new Error("La reponse du serveur est incorrecte");
      }

      const result = await response.json();
      if (!result.success) {
        throw new Error("Le serveur n'a pas confirme l'envoi");
      }

      Swal.fire({
        title: "Message envoye",
        text: "Merci, je reviens vers vous rapidement.",
        icon: "success",
        confirmButtonText: "Parfait",
        customClass: {
          title: "swal-title-red",
          popup: "swal-popup-red",
          confirmButton: "swal-button-red",
        },
      });
      resetForm();
    } catch (error) {
      console.error("Erreur lors de l'envoi :", error);
      Swal.fire({
        title: "Envoi impossible",
        text: "Une erreur s'est produite. Vous pouvez aussi me contacter directement par email ou WhatsApp.",
        icon: "error",
        confirmButtonText: "D'accord",
        customClass: {
          title: "swal-title-red",
          popup: "swal-popup-red",
          confirmButton: "swal-button-red",
        },
      });
    }
  };

  return (
    <main>
      <section className="hero-section" id="about">
        <div className="hero-copy">
          <span className="eyebrow">Disponible pour CDD, CDI, alternance ou mission</span>
          <h1>
            Abdou Kowiyou Bachabi
            <span>Developpeur full-stack et pentester</span>
          </h1>
          <p>
            Je concois des applications web complètes, je les deploie proprement
            et je renforce leur securité. Mon terrain de jeu: React.js, Next.js,
            Node.js, Laravel, Django, CI/CD, VPS Linux et audits web orientes
            OWASP.
          </p>
          <div className="hero-actions">
            <a href="#projets" className="primary-action">
              Voir les projets
              <i className="fa-solid fa-arrow-right"></i>
            </a>
            <a href={cv} download="CV-Abdou-Kowiyou-Bachabi.pdf" className="secondary-action">
              <i className="fa-solid fa-download"></i>
              Telecharger le CV
            </a>
          </div>
          <div className="social-links" aria-label="Liens sociaux">
            <a href="https://wa.me/2290198366038" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <a href="https://www.linkedin.com/in/abdoukowiyoubachabi6427b241/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="mailto:abdoubachabikowiyou@gmail.com" aria-label="Email">
              <i className="fa-solid fa-envelope"></i>
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <img src={moi} alt="Abdou Kowiyou Bachabi" />
          <div className="availability-card">
            <span>Focus actuel</span>
            <strong>Produits web rapides, maintenables et securises</strong>
          </div>
        </div>
      </section>

      <section className="stats-strip" aria-label="Chiffres cles">
        {stats.map((stat) => (
          <div className="stat-item" key={stat.label}>
            <strong ref={stat.ref}>0</strong>
            <span>{stat.label}</span>
          </div>
        ))}
      </section>

      <section id="service" className="section-shell">
        <div className="section-heading">
          <h2>Des services pour passer de l'idee au produit fiable</h2>
          <p>
            Je combine developpement, design pragmatique, deploiement et securite
            pour aider les entreprises a lancer des plateformes qui tiennent.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service) => (
            <article className="service-card" key={service.title}>
              <div className="service-card-top">
                <span>{service.number}</span>
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="projets" className="section-shell projects-section">
        <div className="section-heading">
          <h2>Quelques projets construits, maintenus ou déployés</h2>
          <p>
            Une selection de plateformes web, vitrines, blogs et produits
            digitaux livrés pour des clients et structures variees.
          </p>
        </div>
        <div className="project-filters" role="tablist" aria-label="Filtrer les projets">
          {["Tous", "Application", "Site", "Plateforme", "Blog"].map((item) => (
            <button
              type="button"
              key={item}
              className={filter === item ? "active" : ""}
              onClick={() => setFilter(item)}
            >
              {item}
            </button>
          ))}
        </div>
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <article className="project-card" key={project.title}>
              <img src={project.image} alt={project.title} />
              <div className="project-content">
                <span>{project.type}</span>
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  Ouvrir
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="cv" className="section-shell resume-section">
        <div className="section-heading">
          <h2>Experience, formation et progression continue</h2>
        </div>
        <div className="resume-grid">
          <div>
            <h3 className="resume-title">
              <i className="fa-solid fa-briefcase"></i>
              Experience
            </h3>
            {timeline.map((item) => (
              <article className="timeline-card" key={item.title}>
                <span>{item.period}</span>
                <h4>{item.title}</h4>
                <strong>{item.place}</strong>
                <p>{item.details}</p>
              </article>
            ))}
          </div>
          <div>
            <h3 className="resume-title">
              <i className="fa-solid fa-graduation-cap"></i>
              Education
            </h3>
            {education.map((item) => (
              <article className="timeline-card" key={item.title}>
                <span>{item.period}</span>
                <h4>{item.title}</h4>
                <strong>{item.place}</strong>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section id="competences" className="section-shell">
        <div className="section-heading">
          <h2>Competences utiles pour construire, securiser et deployer</h2>
          <p>
            Mon profil est full-stack, avec une sensibilite forte pour la
            securite applicative, l'automatisation et la maintenance en production.
          </p>
        </div>
        <div className="skills-grid">
          {skills.map((skill) => (
            <div className="skill-pill" key={skill.name}>
              <i className={skill.icon}></i>
              <div>
                <strong>{skill.name}</strong>
                <span>{skill.level}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section id="contact" className="section-shell contact-section">
        <div className="contact-panel">
          <div className="contact-copy">
            <h2>Travaillons ensemble sur une solution utile, rapide et propre.</h2>
            <p>
              Besoin d'un site, d'une application, d'un audit web ou d'un
              deploiement fiable? Envoyez-moi les grandes lignes du projet.
            </p>
            <ul>
              <li>
                <i className="fa-solid fa-envelope"></i>
                <a href="mailto:abdoubachabikowiyou@gmail.com">abdoubachabikowiyou@gmail.com</a>
              </li>
              <li>
                <i className="fa-solid fa-phone"></i>
                <a href="tel:+2290198366038">+229 01 98 36 60 38</a>
              </li>
              <li>
                <i className="fa-solid fa-location-dot"></i>
                <span>Cotonou, Benin</span>
              </li>
            </ul>
          </div>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <input type="text" name="nom" placeholder="Nom" value={formData.nom} onChange={handleChange} />
              <input type="text" name="prenom" placeholder="Prenom" value={formData.prenom} onChange={handleChange} />
            </div>
            <div className="form-row">
              <input type="email" name="email" placeholder="Email" required value={formData.email} onChange={handleChange} />
              <input type="tel" name="tel" placeholder="Telephone" required value={formData.tel} onChange={handleChange} />
            </div>
            <select name="service" value={formData.service} onChange={handleChange} required>
              <option value="">Sélectionner un service</option>
              <option value="Creation de site web">Création de site web</option>
              <option value="Application web">Application web</option>
              <option value="Application web">Refonte et maintenance</option>
              <option value="Audit de securite">Audit de sécurité / Test d'intrusion </option>
              <option value="Deploiement et maintenance">Déploiement et maintenance</option>
            </select>
            <textarea
              name="message"
              rows="6"
              placeholder="Votre message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            <button type="submit">
              Envoyer le message
              <i className="fa-solid fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </section>
    </main>
  );
}
